export const SUPPORTED_LANGUAGES = [
    'en',
    'zh-CN',
]